import { createOptionsFrom } from "@/lib/common/Option";

export const TransactionActionLabels = {
	Purchase: "Purchase",
	Sale: "Sale"
} as const;

export type TransactionAction = keyof typeof TransactionActionLabels;

export const TransactionActionOptions = createOptionsFrom(TransactionActionLabels);
